import type { Shell } from '#packages/apilib';
import { EditorAPIKey } from '#packages/apis';
import type { AiHtmlPromptApi } from './types';
import { generateHtmlPrompt } from './fetchUtils';
import type { AiHtmlGenerationPromptParams } from './types';

export function createAiHtmlPromptApi(shell: Shell): AiHtmlPromptApi {
  const editorApi = shell.getAPI(EditorAPIKey);

  const extractHTMLCodeBlock = (text: string): string | null => {
    const regex = /<html\b[^>]*>([\s\S]*?)<\/html>/;
    const match = text.match(regex);
    return match ? match[0] : null;
  };

  const generateAiHtmlSection = async (
    params: AiHtmlGenerationPromptParams,
    featureName?: string,
  ): Promise<string | null> => {
    const result = await generateHtmlPrompt(params, editorApi, featureName);
    return extractHTMLCodeBlock(result);
  };

  return {
    generateAiHtmlSection,
  };
}
